import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import { getArcadeLinkStyles, Logo } from '@cash-design-system/react'

import type { LinkAdapterProps } from '../../types/types'

const SupportLogo = <T,>({ Link, linkProps }: LinkAdapterProps<T>) => {
  const { darkMode } = useTheme()
  const StyledLink = styled(Link)`
    display: inline-grid;
    grid-template-columns: repeat(2, auto);
    column-gap: 11px;
    align-items: center;

    ${props => getArcadeLinkStyles(props.theme)}

    color: inherit;
  `
  return (
    <StyledLink {...linkProps}>
      <Logo withText data-testid="cash-support-logo" colorVariant={darkMode ? 'white' : 'default'} />
    </StyledLink>
  )
}

export default SupportLogo
